import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider} from '@mui/material/styles';
import {useMemo} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router';
import StyledCookieConsent from './components/StyledCookieConsent';
import MyRouter from './routing/MyRouter';
import LoginRedirect from './security/LoginRedirect';
import {createAppTheme} from './styles/appTheme';
import {themeConfig} from './theme/themeConfig';
import {ErrorBoundary} from './util/errorhandling/ErrorBoundary';

export default function App() {
  const theme = useMemo(() => createAppTheme(themeConfig()), []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginRedirect/>}/>
        <Route
          path="/*"
          element={
            <ThemeProvider theme={theme}>
              <CssBaseline/>
              <ErrorBoundary>
                <MyRouter/>
                <StyledCookieConsent/>
              </ErrorBoundary>
            </ThemeProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
